/**
 * Fixed page sizes for catalog list APIs (products/combos vs other catalog item types).
 * Aligns with platform pagination rules for catalog endpoints.
 */
export const CATALOG_PAGE_SIZE_PRODUCTS_AND_COMBOS = 100;

/** All catalog item types other than products and combos */
export const CATALOG_PAGE_SIZE_OTHER_CATALOG_ITEMS = 500;
